import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import moment from 'moment';
import { isBlank } from '../../utils/BooleanUtility';
import { IST_OFFSET } from '../../config/Constants';
import CountDown from '../../helpers/Counter';
import colors from '../../theme/Colors';
import size from '../../theme/Fonts';

export const ShowCountDown = (props) => {
  const {
    startsAt = '',
    isUpcomingRoutine,
    previousScreen = '',
    showLeftAlignContainer = false,
    disbale7DaysCountdown = false,
  } = props;

  // Early return if startsAt is blank or isUpcomingRoutine is false
  if (isBlank(startsAt)) return null;
  if (!isUpcomingRoutine) return null;

  const currentDateTime = new Date();
  const currentISTDateTime = new Date(currentDateTime.getTime() + IST_OFFSET);

  // Safely parse startsAt and validate it
  const parsedStartsAt = new Date(startsAt);
  if (isBlank(parsedStartsAt.getTime())) {
    return null;
  }

  const startIstDateTime = new Date(parsedStartsAt.getTime() + IST_OFFSET);
  const timeDiff = startIstDateTime.getTime() - currentISTDateTime.getTime();
  const timeDiffInHours = timeDiff / (1000 * 60 * 60);

  // Determine what to display based on the time difference
  let timeToShow = [];
  let timeLabels = {};
  let preText = '';
  let formattedDate = '';
  let textStyle = styles.countdownText;

  if (timeDiffInHours <= 24) {
    // Show timer in hours, minutes, and seconds
    timeToShow = ['H', 'M', 'S'];
    timeLabels = { h: 'hrs', m: 'min', s: 'sec' };
    preText = 'Starting in';
    textStyle = styles.countdownSecondText;
  } else if (timeDiffInHours <= 168 && !disbale7DaysCountdown) {
    // Show timer in days, hours, and minutes
    timeToShow = ['D', 'H', 'M'];
    timeLabels = { d: 'days', h: 'hrs', m: 'min' };
    preText = 'Starting in';
  } else {
    // Show formatted date for routines starting after 7 days
    formattedDate = moment(startIstDateTime).format('Do MMM');
    preText = 'Starting on';
    textStyle = [
      styles.countdownText,
      { fontFamily: 'Roboto-Medium', paddingHorizontal: 0, paddingRight: 4, marginLeft: 6, marginTop: 0 },
    ];
  }

  const containerStyle = showLeftAlignContainer ? styles.leftAlignContainer : styles.countdownContainer;

  const separatorStyle = previousScreen !== 'Chat' ? styles.separatorStyle : {};

  return (
    <View style={containerStyle}>
      <Text style={textStyle}>{preText}</Text>
      {timeDiffInHours <= 24 ||
      (timeDiffInHours <= 168 && !disbale7DaysCountdown) ? (
        <CountDown
          size={10}
          until={timeDiff / 1000}
          digitStyle={styles.digitStyle}
          digitTxtStyle={styles.digitTxtStyle}
          timeLabelStyle={styles.timeLabelStyle}
          separatorStyle={separatorStyle}
          timeToShow={timeToShow}
          timeLabels={timeLabels}
          showSeparator
          showLabels={previousScreen !== 'Chat'}
        />
      ) : (
        <Text style={styles.dateText}>{formattedDate}</Text>
      )}
    </View>
  );
};

// Stylesheet
const styles = StyleSheet.create({
  countdownContainer: {
    flexDirection: 'row',
    paddingRight: 8,
    marginLeft: -6,
    paddingVertical: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftAlignContainer:{
    flexDirection: 'row',
    paddingRight: 8,
    marginLeft: -6,
    paddingVertical: 2,
  },
  countdownText: {
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h4,
    paddingHorizontal: 3,
    // alignSelf: 'center',
    marginTop: 1,
  },

  countdownSecondText: {
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h4,
    paddingHorizontal: 6,
    alignSelf: 'center',
    marginBottom: 12,
  },
  dateText: {
    color: colors.black,
    fontFamily: 'Roboto-Medium',
    fontSize: size.h4,
    alignSelf: 'center',
    height: 16,
  },
  digitStyle: {
    backgroundColor: colors.black,
    borderRadius: 4,
  },
  digitTxtStyle: {
    color: colors.white,
    fontSize: size.h5,
    fontFamily: 'Roboto-Regular',
  },
  timeLabelStyle: {
    color: colors.black,
    fontFamily: 'Roboto-Regular',
    fontSize: 9,
    marginTop: 0,
    marginLeft: 2.1,
  },
  separatorStyle: {
    marginBottom: 12,
    marginLeft: 2,
  }
});